// extracted by mini-css-extract-plugin
export default {"bannerImageContainer":"styles-module__[local]___BHA3s","bannerImage":"styles-module__[local]___+jsAu"};